export const no_tax_reasons =
{
    'Exempt from Tax': {
        'items':
            [
                { 'code': 'VATEX-SA-29', 'reason': 'Financial services mentioned in Article 29 of the VAT Regulations / الخدمات المالية' },
                { 'code': 'VATEX-SA-29-7', 'reason': 'Life insurance services mentioned in Article 29 of the VAT Regulations / عقد تأمين على الحياة' },
                { 'code': 'VATEX-SA-30', 'reason': 'Real estate transactions mentioned in Article 30 of the VAT Regulations / التوريدات العقارية المعفاة من الضريبة' },
            ]
    },
    'Zero rated goods': {
        'items':
            [
                { 'code': 'VATEX-SA-32', 'reason': 'Export of goods / صادرات السلع من المملكة' },
                { 'code': 'VATEX-SA-33', 'reason': 'Export of services /  صادرات الخدمات من المملكة' },
                { 'code': 'VATEX-SA-34-1', 'reason': 'The international transport of Goods / النقل الدولي السريع' },
                { 'code': 'VATEX-SA-34-2', 'reason': 'International transport of passengers / النقل الدولي للركاب' },
                { 'code': 'VATEX-SA-34-3', 'reason': 'Services directly connected and incidental to a Supply of international passenger transport / الخدمات المرتبطة مباشرة أو عرضيًا بتوريد النقل الدولي للركاب' },
                { 'code': 'VATEX-SA-34-4', 'reason': 'Supply of a qualifying means of transport / توريد وسائل النقل المؤهلة' },
                { 'code': 'VATEX-SA-34-5', 'reason': 'Any services relating to Goods or passenger transportation, as defined in article twenty five of these Regulations / الخدمات ذات الصلة بنقل السلع أو الركاب، وفقًا للتعريف الوارد بالمادة الخامسة والعشرين من الالئحة التنفيذية لنظام ضريبة القيامة المضافة' },
                { 'code': 'VATEX-SA-35', 'reason': 'Medicines and medical equipment / الأدوية و المعدات الطبية' },
                { 'code': 'VATEX-SA-36', 'reason': 'Qualifying metals / المعادن المؤهلة' },
                { 'code': 'VATEX-SA-EDU', 'reason': 'Private education to citizen / الخدمات التعليمية الخاصة للمواطنين' },
                { 'code': 'VATEX-SA-HEA', 'reason': 'Private healthcare to citizen / الخدمات الصحية الخاصة للمواطنين' },
                { 'code': 'VATEX-SA-MLTRY', 'reason': 'Supply of qualified military goods  / توريد السلع العسكرية المؤهلة' },
            ]
    },
    'Outside scope of tax / Not subject to VAT services':
    {
        'items':
            [
                { 'code': 'VATEX-SA-OOS', 'reason': 'supply of qualified military goods  / توريد السلع العسكرية المؤهلة' },
            ]
    }
}

export const vat_types = () => {
    var res = []
    for (const el in no_tax_reasons) {
        res.push({ 'label': el, 'value': el })
    }
    return res
}

export const vat_reasons = (selected) => {
    var res = []
    if (selected) {
        for (const el of no_tax_reasons[selected].items) {
            res.push({ 'label': el.reason, 'value': `${el.code}|${el.reason}` })
        }
    }
    return res
}


export const checkZeroTaxLines = (lines) => {
    return lines.filter((line) => (parseFloat(line.TaxAmount || 0) === 0) && !line.vatType && !line.vatReason);
  };


export const PrepareZeroTaxLines = async (client, document, selectedOrganisation) => {
    if (document.hasZeroTax) {
        try {
            const tax_reasons = await client.get(`xero_actions/${selectedOrganisation.id}/document_exempt_reason?InvoiceID=${document.InvoiceID || document.CreditNoteID}`).get('data').get('ZeroTaxReasons')
            const _document = {
                ...document,
                LineItems: document.LineItems.map(i => ({
                    ...i,
                    vatType: tax_reasons?.[i.LineItemID]?.vatType,
                    vatReason: tax_reasons?.[i.LineItemID]?.vatReason,
                }))
            }
            return checkZeroTaxLines(_document?.LineItems)
        } catch (err) { }
    }
    return []
}

export const fetchZatcaApps = async (zatca) => {
    try {
        var response = await zatca.get("sdk");
        const apps = response?.data?.map(app => { return { 'label': `${app.common_name} (${app.id_number})`, 'value': app.id } })
        return apps
    } catch (error) {
        console.error("Error fetching data:", error);
    }
    return []
};